import { Routine } from 'redux-saga-routines';
import {
  togglePositionProfileRoutine,
  fetchPositionRoutine,
  fetchCandidatesByPositionIdRoutine,
  fetchPositionCountersRoutine, changePositionNameRoutine, checkPositionNameRoutine, setNewPositionNameRoutine
} from '../routines';
import { IPositionProfile } from '../../../common/models/position/IPositionProfile';
import { ICandidatePositionProfile } from '../../../common/models/candidate/ICandidatePositionProfile';
import { CandidateCounts } from '../../../common/models/candidate/CandidateCounts';
import { fetchPositionsRoutine } from '../../Dashboard/routines';
import { updateCandidateStatusRoutine } from '../../../containers/CandidatesBulkActions/routines';
import { mergeContactsRoutine } from '../../../containers/MergeContacts/routines';
import { IPositionAvgCounters } from '../../../common/models/position/IPositionAvgCounters';
import { showPositionProfileModalRoutine } from '../../../routines/history';

export type PositionProfileState = {
  positionId?: string;
  positionName?: string;
  position?: IPositionProfile;
  loading: boolean;
  candidates: ICandidatePositionProfile[];
  total: number;
  filterCounters: CandidateCounts | undefined;
  averageCounters: IPositionAvgCounters;
  isNameTaken: boolean;
  isChecking: boolean;
  isNewNameSetted: boolean;
};

const initialState = {
  positionId: undefined,
  positionName: undefined,
  position: undefined,
  loading: false,
  candidates: [],
  total: 0,
  averageCounters: { active: 0, hired: 0, notHired: 0 },
  filterCounters: undefined,
  isNameTaken: false,
  isChecking: false,
  isNewNameSetted: false
};

export const positionProfile = (
  state: PositionProfileState = initialState,
  { type, payload }: Routine<any>
): PositionProfileState => {
  switch (type) {
    case togglePositionProfileRoutine.TRIGGER:
      return {
        ...initialState,
        positionId: payload,
        candidates: state.candidates,
        total: state.total
      };
    case showPositionProfileModalRoutine.TRIGGER:
      return {
        ...state,
        loading: true,
        candidates: [],
        total: 0
      };
    case fetchPositionRoutine.SUCCESS:
      const { filterCounters, averageCounters, ...rest } = payload;
      return {
        ...state,
        filterCounters,
        averageCounters,
        position: rest,
        positionName: rest.name
      };
    case fetchCandidatesByPositionIdRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchCandidatesByPositionIdRoutine.SUCCESS:
      const candidates = payload.reset ? payload.items : [...state.candidates, ...payload.items];
      return {
        ...state,
        candidates,
        total: payload.total,
        loading: false
      };
    case fetchPositionCountersRoutine.SUCCESS:
      return {
        ...state,
        filterCounters: payload
      };
    case updateCandidateStatusRoutine.SUCCESS:
    case mergeContactsRoutine.SUCCESS:
      return {
        ...state,
        filterCounters: undefined
      };
    case fetchCandidatesByPositionIdRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case changePositionNameRoutine.TRIGGER:
      return {
        ...state,
        positionName: payload
      };
    case checkPositionNameRoutine.TRIGGER:
      return {
        ...state,
        isChecking: true
      };
    case checkPositionNameRoutine.SUCCESS:
      return {
        ...state,
        ...payload,
        isChecking: false
      };
    case checkPositionNameRoutine.FAILURE:
      return {
        ...state,
        isChecking: false
      };
    case setNewPositionNameRoutine.SUCCESS:
      return {
        ...state,
        isNewNameSetted: true
      };
    case fetchPositionsRoutine.TRIGGER:
      return {
        ...state,
        isNewNameSetted: false
      };
    default:
      return state;
  }
};
